import { RecentlyReleasedItem } from '../types'

export const RECENTLY_RELEASED_ITEMS: RecentlyReleasedItem[] = [
  {
    type: 'NEW FEATURE',
    title: 'Evidence Library Documents',
    description:
      'The Documents module gives your evidence one secure, searchable home. Upload and describe files in bulk, tag them so colleagues can find them and georeference each one to the place it relates to. Permissions follow the user groups you already manage, so staff and external partners work from the same evidence base while you stay in control',
    action: 'learn-more',
    href: 'https://resilience-explorer.com/products/evidence/documents',
  },
  {
    type: 'NEW FEATURE',
    title: 'Refreshed Home and Guide modules',
    description:
      "We've revamped the Home and Guide sections to make it easier to find resources, access tutorials, and stay up-to-date with the latest features and updates. Explore the new layout and discover all the helpful content we've curated for you.",
    action: 'learn-more',
    href: '/app/home',
  },
  {
    type: 'NEW FEATURE',
    title: 'Property Explorer',
    description:
      'Resilience Explorer® Property brings hazard data, climate scenarios, risk classifications, mapping, and report generation into a single operational workflow, producing consistent, regulation-aligned outputs directly from council-approved datasets.',
    action: 'learn-more',
    href: 'https://resilience-explorer.com/products/property',
  },
  {
    type: 'BETA RELEASE',
    title: 'Risk Table',
    description:
      'Sort and filter your assets by type, hazard, consequence, and exposure all in one place, and clicking any row takes you straight to that asset on the map. Built for asset managers and planners who need to quickly see where the most risk is across a portfolio.',
    action: 'feedback',
    href: 'https://forum.resilience-explorer.com/t/all-your-risk-data-one-table-no-export-needed/45',
  },
  {
    type: 'TECH UPDATE',
    title: 'Improved map performance',
    description:
      'Significant rendering improvements for large hazard datasets — faster load times and smoother interactions across all map views.',
    action: 'release-notes',
    href: '',
  },
  {
    type: 'NEW FEATURE',
    title: 'Public Risk Stories',
    description:
      'Resilience Explorer® Risk Stories can now be made public and shared or embedded into your website via a simple URL, making it easy to share insights with stakeholders who don’t have access to the full platform. Contact your relationship manager for more infromation,',
    action: 'none',
    href: '',
  },
  {
    type: 'NEW FEATURE',
    title: 'Workspaces',
    description:
      'Organise your saved views, analysis results, and map configurations into custom workspaces for different projects, teams, or focus areas.',
    action: 'tutorial',
    href: '/app/guide/tutorials/organise-with-workspaces',
  },
  {
    type: 'NEW FEATURE',
    title: 'Resilience Explorer® Forum',
    description:
      'Join the conversation on our new community forum! Connect with other users, share tips and best practices, ask questions, and provide feedback directly to our team.',
    action: 'learn-more',
    href: 'https://forum.resilience-explorer.com',
  },
  {
    type: 'TECH UPDATE',
    title: 'Authentication improvements',
    description:
      'Faster login flows and improved session handling across all supported identity providers. Logins are now handled via a dedicated authentication service, improving reliability and security.',
    action: 'none',
    href: '',
  },
]
